export function MatchCardSkeleton() {
  return (
    <div className="glass rounded-2xl p-4 animate-pulse">
      <div className="flex items-center justify-between mb-4">
        <div className="h-3 w-20 bg-base-600 rounded" />
        <div className="h-3 w-10 bg-base-600 rounded" />
      </div>
      <div className="space-y-3">
        {[0, 1].map((i) => (
          <div key={i} className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-base-600" />
              <div className="h-3 w-24 bg-base-600 rounded" />
            </div>
            <div className="h-4 w-4 bg-base-600 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function MatchGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <MatchCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function PlayerSkeleton() {
  return (
    <div className="w-full aspect-video rounded-2xl bg-base-800 animate-pulse flex items-center justify-center">
      <div className="w-14 h-14 rounded-full border-2 border-base-600 border-t-emerald animate-spin" />
    </div>
  );
}

export function SidePanelSkeleton() {
  return (
    <div className="glass rounded-2xl p-5 space-y-4 animate-pulse">
      <div className="h-4 w-32 bg-base-600 rounded" />
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="h-3 w-full bg-base-600 rounded" />
      ))}
    </div>
  );
}

export function TickerSkeleton() {
  return (
    <div className="h-9 bg-base-800/60 border-y border-white/5 flex items-center px-4">
      <div className="h-3 w-64 bg-base-600 rounded animate-pulse" />
    </div>
  );
}
